import { agency } from "./agency.api";
import { agencySettings } from "./agency_settings.api";
import { agencyUser } from "./agency_user.api";
import { agencyWa } from "./agency_wa.api";
import { attendance } from "./attendance.api";
import { attendanceSubmission } from "./attendance_submission.api";
import { buildURI, get, post } from "./common";
import { debugTools } from "./debug_tools.api";
import { device } from "./device.api";
import { devtools } from "./devtools.api";
import { group } from "./group.api";
import { scheduleGlobal } from "./schedule_global.api";
import { scheduleGroup } from "./schedule_group.api";
import { scheduleTimeTable } from "./schedule_time_table.api";
import { settings } from "./settings.api";
import { user } from "./user.api";
import { userAttendance } from "./user_attendance.api";
import { userBio } from "./user_bio.api";
import { userDeviceBinding } from "./user_device_binding.api";
import { userLocation } from "./user_location.api";

export const api = {
    buildUri: buildURI,
    raw: {
        get: get,
        post: post,
    },
    agency: agency,
    agencySettings: agencySettings,
    agencyUser: agencyUser,
    agencyWa: agencyWa,
    attendance: attendance,
    attendanceSubmission: attendanceSubmission,
    debugTools: debugTools,
    device: device,
    devtools: devtools,
    group: group,
    scheduleGlobal: scheduleGlobal,
    scheduleGroup: scheduleGroup,
    scheduleTimeTable: scheduleTimeTable,
    settings: settings,
    user: user,
    userAttendance: userAttendance,
    userBio: userBio,
    userDeviceBinding: userDeviceBinding,
    userLocation: userLocation,
};
